import { render, staticRenderFns } from "./TasteKindSelects.vue?vue&type=template&id=3d0d6fd8&"
import script from "./TasteKindSelects.vue?vue&type=script&lang=js&"
export * from "./TasteKindSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports